
ADILF.define('adilf/apps/profile/views/content-list-view',['require','exports','module','streamhub-sdk/jquery','inherits','adilf/apps/profile/views/content-view','streamhub-sdk/content/views/content-list-view','adilf/util/article-stub'],function (require, exports, module) {/* User Profile List View */
'use strict';

var jquery = require('streamhub-sdk/jquery');
var inherits = require('inherits');
var ProfileContentView = require('adilf/apps/profile/views/content-view');
var ContentListView = require('streamhub-sdk/content/views/content-list-view');
var articleStub = require('adilf/util/article-stub');

var ProfileContentListView = function (opts) {
    opts = opts || {};
    this._prefix = opts.prefix;
    this._adsHelper = opts.adsHelper;
    ContentListView.apply(this, arguments);
};

inherits(ProfileContentListView, ContentListView);

ProfileContentListView.prototype.elClass += ' adi-profile-content-list';

ProfileContentListView.prototype.events = ContentListView.prototype.events.extended({
    'showMore.hub': function (e) {
        ContentListView.prototype.events['showMore.hub'].call(this, e);
        this._adsHelper.pageMore();
    }
});

/**
 * Create a ContentView to display a newly added piece of Content.
 * In this case, create an instance of adilf/apps/profile/views/content-view.
 * This overrides the default ContentListView#createContentView
 */
ProfileContentListView.prototype.createContentView = function (content) {
    if(articleStub.test(content)) {
        // content is stub! aborting!
        return;
    }
    var contentView = new ProfileContentView({
        content: content,
        prefix: this._prefix
    });
    return contentView;
};

ProfileContentListView.prototype.getTemplateContext = function () {
    var context = ContentListView.prototype.getTemplateContext.call(this);
    context.prefix = this._prefix;
    return context;
};

module.exports = ProfileContentListView;

});
